import { getPrefixRoute } from "../../../RBACPlugin";

const REACT_APP_API_ENDPOINT = process.env.REACT_APP_EID_ADMIN_API_ENDPOINT;
const USER_SEVICE_BASE_URL = REACT_APP_API_ENDPOINT + "/api/v1/users";
const PROFILE_SEVICE_BASE_URL = REACT_APP_API_ENDPOINT + "/api/v1/profile";

const USER_BASE_URL = REACT_APP_API_ENDPOINT + "/api/v1";
const USER_API_ENDPOINT = getPrefixRoute(USER_BASE_URL) + "/users";

export default {

    // User
    GET_USER_LIST                    :   USER_SEVICE_BASE_URL + "/list",
    CREATE_USER:                         USER_SEVICE_BASE_URL + "/create/profile",
    LIST_USER_WITH_NO_ORG:              USER_SEVICE_BASE_URL + "/list/all",
    VIEW_USER:                           USER_SEVICE_BASE_URL + "/view",
    UPDATE_USER:                        USER_SEVICE_BASE_URL + "/update",
    LIST_USER_FILTER:                   USER_SEVICE_BASE_URL + "/list/filter",
    LIST_ALL_USER_FOR_DROPDOWN:           USER_SEVICE_BASE_URL + "/list/search",

    // profile
    GET_USER_PROFILE:                   PROFILE_SEVICE_BASE_URL + "/user",
    UPDATE_PROFILE:                     PROFILE_SEVICE_BASE_URL + "/update",
    UPDATE_PROFILE_STATUS:              PROFILE_SEVICE_BASE_URL + "/update/status",
    VIEW_USER_PROFILE:                  PROFILE_SEVICE_BASE_URL + "/view"
}
